import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { useExternalDemoMode } from "./useExternalDemoMode"

const routesWithBanner = [
  "/dashboard",
  "/alerts",
  "/configure",
  "/credits",
  "/team",
  "/integrations",
  "/health"
]

export const useDemoBannerVisible = () => {
  const { pathname } = useLocation()
  const auth = useSelector((state) => state.auth)
  const externalDemoMode = useExternalDemoMode()
  const isAdmin = auth?.isAdmin

  if (isAdmin) return false

  if (!auth?.userInfo?.is_demo && !auth?.userInfo?.is_light_mode && !externalDemoMode) {
    return false
  }

  return routesWithBanner.some((route) => pathname.startsWith(route))
}

export default useDemoBannerVisible
